module.exports = __webpack_public_path__ + "static/media/RL_LL_BONNIE.c46c4ca7.webp";